import {Article} from "../types/article";

const API_URL = process.env.REACT_APP_API_URL;
if (!API_URL) {
    throw new Error('環境変数が設定されていません');
}

export const getArticles = async (): Promise<Article[]> => {
    const res = await fetch(`${API_URL}/posts`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ action: 'list' })
    });

    const data = await res.json();

    // APIからのレスポンスをArticle型に整形
    return data.items.map((item: any) => ({
        id: item.PostID,
        title: item.Title,
        createdAt: item.PublishedDate,
        updatedAt: item.UpdatedDate ?? undefined,
        content: item.Content ?? ''
    }));
};